export default {
  en: {
    RecommendApplication: {
      title: 'Recommended Applications',
      tableColumn: 'Applications'
    },
    RecommendProduct: {
      title: 'Recommended Products'
    },
    RecommendModal: {
      title: 'Recommended'
    }
  },
  es: {
    RecommendApplication: {
      title: 'Aplicaciones recomendadas',
      tableColumn: 'Aplicaciones'
    },
    RecommendProduct: {
      title: 'Productos Recomendados'
    },
    RecommendModal: {
      title: 'Recomendados'
    }
  },
  'pt-br': {
    RecommendApplication: {
      title: 'Aplicações recomendadas',
      tableColumn: 'Aplicações'
    },
    RecommendProduct: {
      title: 'produtos recomendados'
    },
    RecommendModal: {
      title: 'Recomendados'
    }
  }
}
